// Consume the already-loaded Mockup Set classification; never fetch it twice.
if (!customElements.get('ornament-benefits')) {
  customElements.define('ornament-benefits', class extends HTMLElement {
    connectedCallback() {
      const root = document.querySelector('[data-wooden-pdp]');
      if (!root) return;
      this.observer?.disconnect();
      const render = () => {
        const kind = root.dataset.ornamentMaterial;
        const supported = ['ceramic', 'glass', 'suncatcher'].includes(kind);
        this.hidden = !supported;
        if (!supported || this.dataset.material === kind) return;
        const template = this.querySelector(`template[data-benefits-kind="${kind}"]`);
        if (!template) { this.hidden = true; return; }
        this.querySelector('[data-benefits-content]').replaceChildren(template.content.cloneNode(true));
        this.dataset.material = kind;
      };
      this.observer = new MutationObserver(render);
      this.observer.observe(root, {attributes: true, attributeFilter: ['data-ornament-material']});
      render();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
